import React from 'react';
import { useSubject } from '@base/utils/helpers';
import {IMovesHistory, HistoryEntry } from '../model/movesHistory';
import Color from '@base/features/game/model/color';
import dice_white from './assets/images/dice-white.svg';
import dice_black from './assets/images/dice-black.svg';
import styles from '../styles/movesWindow.module.scss';
import bg from './assets/images/dice_bg.svg';

export default function MovesWindow(props: {
  movesHistory: IMovesHistory;
  matchString: string;
  tickets?: string;
}) {
  const movesHistory = useSubject(props.movesHistory.onMoveHistoryChangedEvent, props.movesHistory.history);
  const current = useSubject(props.movesHistory.onCurrentTurnChanged);

  return (
    <>
      <MatchInfo tickets={props.tickets}>{props.matchString}</MatchInfo>
      <div
        className={styles.movesWindow}
        style={{
          backgroundImage: movesHistory?.length ? 'none' : `url(${bg})`,
        }}
      >
        {movesHistory ? <MovesList>{movesHistory}</MovesList> : null}
      </div>
      <div className={styles.current}>
        {current && movesHistory &&
          <Move move={current} index={movesHistory.length + 1} />
        }
      </div>
    </>
  );
}

const MovesList = (props: { children: HistoryEntry[] }) => (
  <div className={styles.list}>
    {props.children.map((move, index) =>
      <Move move={move} index={index + 1} key={index} />
    )}
  </div>
);

const Move = (props: { move: HistoryEntry; index: number }) => (
  <div className={styles.move}>
    <span>{props.index}</span>
    <Cube color={props.move.color} number={props.move.dice1} />
    <Cube color={props.move.color} number={props.move.dice2} />
    <span>{props.move.moves}</span>
  </div>
);

const MatchInfo = (props: { children: string; tickets?: string }) => (
  <div className={styles.matchInfo}>
    <span>{props.children.replace('_', ': ')}</span>
    {props.tickets && <span>{props.tickets}</span>}
  </div>
);

const Cube = (props: { color: Color; number: number }) => (
  <div
    className={styles.cube}
    style={{
      backgroundImage: `url(${props.color === Color.White ? dice_white : dice_black})`,
      backgroundPosition: `-${(props.number - 1) * 15}px 0`,
    }}
  />
);
